import { useState } from "react";
import useDialog from "../../../../hooks/useDialog";

export const useResetConfirmDialog = () => {
    
  const dialogStatus = useDialog();
  const [callbacks, setCallbacks] = useState({
    "reset" : () => {},
    "submit" : () => {},
    "return" : () => {}
  });

  const openDialog = () => {
    dialogStatus.open();
  }

  const setOnReset = (onResetFunc) => {
    setCallbacks((prev) => ({
      ...prev,
      "reset": onResetFunc
    }))
  }

  const setOnSubmit = (onSubmitFunc) => {
    setCallbacks((prev) => ({
      ...prev,
      "submit": onSubmitFunc
    }))
  }

  const setOnReturn = (onReturnFunc) => {
    setCallbacks((prev) => ({
      ...prev,
      "return": onReturnFunc
    }))
  }
  
  const doReturn = () => {
    dialogStatus.onClose(null)();
    callbacks["return"]();
  }

  const doSubmitAndReset = () => {
    dialogStatus.onClose(null)();
    callbacks["submit"]();
    callbacks["reset"]();
  }

  const doResetWithoutSubmit = () => {
    dialogStatus.onClose(null)();
    callbacks["reset"]();
  }
  
  return {
    openDialog,
    setOnReset,
    setOnSubmit,
    setOnReturn,
    dialogParams : {
      isOpen: dialogStatus.isOpen,
      doReturn,
      doSubmitAndReset,
      doResetWithoutSubmit
    }
  }
}